import styled from 'styled-components';

export const FadeInContainer = styled.div`
    opacity: ${(props: {isVisible: boolean, transitionSeconds?: number}) => props.isVisible ? 1 : 0};
    transition: opacity ${(props) => props.transitionSeconds || '0.3'}s ease-in-out;
`;
